import { Form, Formik } from "formik";
import { useState } from "react";
import { object, string } from "yup";
import FormikSubmitButton from "../../UI/FormikSubmitButton";
import Callout from "../../UI/Callout";
import ModalDialog, {
  ModalDialogBody,
  ModalDialogFooter,
} from "../../UI/ModalDialog";
// @ts-expect-error pure js
import TextInput from "../../UI/TextInput";
// @ts-expect-error pure js
import TextArea from "../../UI/TextArea";
// @ts-expect-error pure js
import Checkbox from "../../UI/Checkbox";
// @ts-expect-error pure js
import AffectationSelect from "../../UI/AffectationSelect";
import { BalanceDomain } from "../../../utils/constants/balances";
// @ts-expect-error pure js
import { handleAPIError } from "../../../utils";
// @ts-expect-error pure js
import { sanitizeValues } from "../../../models/utils";
import styles from "./PriorityActionForm.module.css";

interface PriorityActionFormProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (values: Record<string, unknown>) => Promise<void>;
}

interface FormValues {
  title: string;
  description: string;
  domaine: string;
  id_tenant: string;
  id_bien: string;
  id_profile_bailleur: string;
  id_property_folder: string;
  remind_at: string;
  remind_by_mail: boolean;
}

const ALLOWED_DOMAINS = [
  BalanceDomain.TENANT,
  BalanceDomain.PROPERTY,
  BalanceDomain.PROFILE_BAILLEUR,
];

const VALIDATION_SCHEMA = object({
  title: string().required("Le titre est requis"),
  domaine: string().required(" "),
});

export default function PriorityActionForm({
  open,
  onOpenChange,
  onSubmit,
}: PriorityActionFormProps) {
  const [error, setError] = useState("");

  const initialValues: FormValues = {
    title: "",
    description: "",
    domaine: "",
    id_tenant: "",
    id_bien: "",
    id_profile_bailleur: "",
    id_property_folder: "",
    remind_at: "",
    remind_by_mail: false,
  };

  async function submitHandler(
    values: FormValues,
    { resetForm }: { resetForm: () => void },
  ) {
    setError("");
    try {
      await onSubmit(sanitizeValues(values));
      resetForm();
      onOpenChange(false);
    } catch (err) {
      setError(handleAPIError(err));
    }
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={VALIDATION_SCHEMA}
      onSubmit={submitHandler}
    >
      {({ resetForm, values }) => (
        <ModalDialog
          size="sm"
          open={open}
          header="Ajouter une action prioritaire"
          onOpenChange={(nextOpen) => {
            if (!nextOpen) {
              resetForm();
              setError("");
            }
            onOpenChange(nextOpen);
          }}
        >
          <Form>
            <ModalDialogBody className={styles.form}>
              <TextInput
                type="text"
                label="Titre"
                name="title"
                placeholder="Relancer l'artisan"
                marginForm=""
                mandatory
              />
              <TextArea
                name="description"
                label="Description"
                rows={3}
                marginForm=""
              />
              <AffectationSelect
                label="Associer à"
                placeholder="Un profil, un locataire ou un bien"
                allowedDomains={ALLOWED_DOMAINS}
                resetTypeOnChange={false}
                mandatory
              />
              <TextInput
                type="date"
                label="Me le rappeler le"
                name="remind_at"
                marginForm=""
              />
              {values.remind_at && (
                <Checkbox name="remind_by_mail">
                  M'envoyer un mail de rappel
                </Checkbox>
              )}
              <Callout variant="danger">{error}</Callout>
            </ModalDialogBody>
            <ModalDialogFooter>
              <FormikSubmitButton>Ajouter</FormikSubmitButton>
            </ModalDialogFooter>
          </Form>
        </ModalDialog>
      )}
    </Formik>
  );
}
